import API from './API.js'
import axios from 'axios'

export default class QuranScheduleDate extends API {
  constructor() {
    super('quran-schedule-date')
  }
   
  async assignTeacherDate(id, params) {
    const response = await axios.post(`quran-schedule-date/assign-teacher-date/${id}`, params)
    return response.data
  }
  async getTeacherSchedule(id,params) {
    const response = await axios.get(`quran-schedule-date/get-teacher-schedule/${id}`, { params })
    return response.data
  }
  async getTeacherSchedules(params) {
    const response = await axios.get('quran-schedule-date/get-teachers-schedules', { params });

    return response.data
  }
}
